// Supplier-side auth storage — deliberately separate keys from
// Utils/auth.js (internal staff). Suppliers carry a different token
// (signed with SUPPLIER_JWT_SECRET on the backend) and must never be
// confused with an internal staff session, or vice versa.

export const setSupplierAuthData = (token, supplier) => {
  localStorage.setItem("supplier_token", token);
  localStorage.setItem("supplier_info", JSON.stringify(supplier));
  localStorage.setItem("supplier_isAuthenticated", "true");
};

export const clearSupplierAuthData = () => {
  localStorage.removeItem("supplier_token");
  localStorage.removeItem("supplier_info");
  localStorage.removeItem("supplier_isAuthenticated");
};

export const getSupplierAuthData = () => {
  const token = localStorage.getItem("supplier_token");
  const infoRaw = localStorage.getItem("supplier_info");
  return {
    token,
    supplier: infoRaw ? JSON.parse(infoRaw) : null,
  };
};

export const isSupplierAuthenticated = () => {
  return Boolean(
    localStorage.getItem("supplier_token") &&
      localStorage.getItem("supplier_isAuthenticated")
  );
};
